function unescapeHtml(safe) {
    return safe
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
}

function scrollTo(section) {
    if (section === "response") {
        // Go to validated result
        const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    } else if (section === "top") {
        window.scroll({ top: 0, behavior: 'smooth' });
    }
}

ko.bindingHandlers.codemirror = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var options = viewModel.options || {};
        options.value = ko.unwrap(valueAccessor());
        element.editor = CodeMirror.fromTextArea(element, options);
        element.editor.on('change', function(cm) {
            var value = valueAccessor();
            value(cm.getValue());
        });
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observedValue = ko.unwrap(valueAccessor());
        if (element.editor) {
            element.editor.setValue(observedValue);
            element.editor.execCommand('goDocEnd');
            element.editor.refresh();
        }
    }
};

var VM = function () {
    var self = this;

    self.showResult = ko.observable(false);
    self.inputJsonOne = ko.observable(`{
   "name": "John",
   "age": 30,
   "address": {
      "city": "New York"
   }
}`);
    self.inputJsonTwo = ko.observable(`{
   "age": 31,
   "email": "john@example.com",
   "address": {
      "zip": "10001"
   }
}`);
    self.emptyInput = ko.pureComputed(function(){
        return self.inputJsonOne() === "" || self.inputJsonTwo() === "";
    });
    self.status = ko.observable('');
    self.errors = ko.observableArray([]);
    self.mergedJson = ko.observable('');

    self.options = {
        lineNumbers: true,
        lineWrapping: true,
        mode: "application/json",
        matchBrackets: true,
        extraKeys: {
            "F11": function(cm) {
                cm.setOption("fullScreen", !cm.getOption("fullScreen"));
            },
            "Esc": function(cm) {
                if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
            }
        }
    };

    self.jsonTemplateOptions = ko.observableArray([
        { label: 'Compact', value: 0 },
        { label: 'One space', value: 1 },
        { label: 'Two spaces', value: 2 },
        { label: 'Three spaces', value: 3 },
        { label: 'Four spaces', value: 4 }
    ]);
    self.selectedJsonTemplate = ko.observable(3);

    self.resetObservables = function() {
        self.errors.removeAll();
        self.status('');
        self.showResult(false);
        self.mergedJson('');
    }

    self.validate = function () {
        self.resetObservables();

        let objOne, objTwo;
        let isError = false;
        
        try {
            objOne = JSON.parse(self.inputJsonOne());
        } catch (e) {
            try {
                jsonlint.parse(self.inputJsonOne());
            } catch (err) {
                self.errors.push({ field: "JSON 1", message: err.message });
                isError = true;
            }
        }

        try {
            objTwo = JSON.parse(self.inputJsonTwo());
        } catch (e) {
            try {
                jsonlint.parse(self.inputJsonTwo());
            } catch (err) {
                self.errors.push({ field: "JSON 2", message: err.message });
                isError = true;
            }
        }

        if (isError) {
            self.status('Invalid JSON');
            self.showResult(true);
            scrollTo('response');
            return;
        }

        const rezultat = window.deepmerge(objOne, objTwo);
        self.mergedJson(JSON.stringify(rezultat, null, self.selectedJsonTemplate()));
        self.showResult(true);
        scrollTo('response');

        self.selectedJsonTemplate.subscribe(function(newValue) {
            self.mergedJson(JSON.stringify(rezultat, null, self.selectedJsonTemplate()));
        });
    }

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });

    // Copy to clipboard button
    var copyJson = new ClipboardJS('#cpybutton', {
        text: function () {
            return unescapeHtml(JSON.stringify(self.mergedJson(), null, self.selectedJsonTemplate()));
        }
    });
    copyJson.on('success', function(e) {
        e.clearSelection();
        const cpyButton = new bootstrap.Tooltip(document.querySelector('#cpybutton'));
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy to clipboard for markdown button
    var mrkdStacktrace = new ClipboardJS('#mrkdbutton', {
        text: function () {
            return '```json\n' + unescapeHtml(JSON.stringify(self.mergedJson(), null, self.selectedJsonTemplate())) + '\n```';
        }
    });
    mrkdStacktrace.on('success', function (e) {
        e.clearSelection();
        const mrkdButton = new bootstrap.Tooltip(document.querySelector('#mrkdbutton'));
        mrkdButton.show();
        setTimeout(() => mrkdButton.hide(), 1000);
    });

    // Download file
    self.createFile = function() {
        var outputCM = document.querySelector('.textarea-output .CodeMirror')?.CodeMirror.getValue();
        var fileName = "merged";

        if(outputCM != "") {
            if (outputCM.trim().length != 0) {
                var blob = new Blob([ "" + outputCM + "" ], {
                    type : "text/plain;charset=utf-8"
                });
                saveAs(blob, fileName + ".json");
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    document.querySelector("#json-file-1").addEventListener('focus', (evt) => evt.target.select());
    document.querySelector("#json-file-2").addEventListener('focus', (evt) => evt.target.select());

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});